<template>
  <div class="loader">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>